export default {
    toPay: 'To pay',
    phone: 'Phone number',
    phonePlaceholder: '+1 (___) ___-____',
    sendCode: 'Send code',
    sending: 'Sending...',
    smsCode: 'SMS code',
    changePhone: 'Change number',
    confirm: 'Confirm',
    confirming: 'Verifying...',
    resendAfter: 'Resend in {n} sec.',
    resendText: 'Did not receive SMS?',
    resendLink: 'Try again',
    paymentConfirmed: 'Payment confirmed',
    redirecting: 'Redirecting...',
    errorSend: 'Failed to send code. Please try again.',
    errorOtp: 'Invalid code. Please try again.',
    invalidLink: 'Invalid link',
    loadingTitle: 'Failed to load payment',
    statusFallback: 'Unknown error, please contact support',
    status_202: 'Operation successfully completed',
    status_204: 'Operation has already been confirmed',
    status_206: 'Operation created, PIN sent to phone',
    status_208: 'PIN successfully resent',
    status_300: 'Unknown error, please contact support',
    status_601: 'Operation not found',
    status_602: 'Invalid PIN code',
    status_603: 'Operator error, please try again later',
    status_604: 'Request timed out, please try again later',
    status_605: 'Insufficient funds or reservation error',
    status_606: 'Deduction error, please contact support',
    status_607: 'PIN resend requested too frequently',
    status_608: 'Not enough balance',
    status_609: 'Subscriber not found',
}
